<template>
  <div v-html="screen.html" />
</template>

<script>
export default {
  props: {
    screen: {
      type: Object,
      required: true
    }
  }
};
</script>
